/* enemy-cart.js — cart drawer con Shopify AJAX API */
(function () {
  'use strict';

  const CART_URL = '/cart.js';
  const CART_ADD_URL = '/cart/add.js';
  const CART_CHANGE_URL = '/cart/change.js';

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(cents / 100);
  }

  async function fetchCart() {
    const res = await fetch(CART_URL);
    return res.json();
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    return res.json();
  }

  async function changeQuantity(lineIndex, quantity) {
    const res = await fetch(CART_CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity })
    });
    return res.json();
  }

  function renderCart(cart) {
    const itemsEl = document.querySelector('.ec-cart-drawer__items');
    const priceEl = document.querySelector('.ec-cart-drawer__subtotal-price');
    const countEls = document.querySelectorAll('.ec-header__cart-count');

    if (priceEl) priceEl.textContent = formatMoney(cart.total_price);
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (!itemsEl) return;
    itemsEl.innerHTML = '';

    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<p style="color:var(--ec-text-2);font-size:12px;padding:20px 0;">Tu carrito está vacío.</p>';
      return;
    }

    cart.items.forEach((item, index) => {
      const el = document.createElement('div');
      el.className = 'ec-cart-item';
      el.innerHTML = `
        <div class="ec-cart-item__image">
          <img src="${item.image}" alt="${item.product_title}" loading="lazy">
        </div>
        <div class="ec-cart-item__info">
          <div>
            <div class="ec-cart-item__name">${item.product_title}</div>
            <div class="ec-cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          </div>
          <div class="ec-cart-item__bottom">
            <div class="ec-cart-item__qty">
              <button data-line="${index + 1}" data-qty="${item.quantity - 1}">−</button>
              <span class="ec-cart-item__qty-num">${item.quantity}</span>
              <button data-line="${index + 1}" data-qty="${item.quantity + 1}">+</button>
            </div>
            <span class="ec-cart-item__price">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
      `;
      itemsEl.appendChild(el);
    });

    itemsEl.querySelectorAll('button[data-line]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const cart = await changeQuantity(parseInt(btn.dataset.line), parseInt(btn.dataset.qty));
        renderCart(cart);
      });
    });
  }

  function openDrawer() {
    const drawer = document.querySelector('.ec-cart-drawer');
    const overlay = document.querySelector('.ec-cart-overlay');
    drawer?.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.body.classList.add('ec-no-scroll');
    fetchCart().then(renderCart);
  }

  function closeDrawer() {
    document.querySelector('.ec-cart-drawer')?.classList.remove('is-open');
    document.querySelector('.ec-cart-overlay')?.classList.remove('is-visible');
    document.body.classList.remove('ec-no-scroll');
  }

  document.addEventListener('DOMContentLoaded', () => {
    /* Open on cart icon */
    document.querySelectorAll('.ec-header__icon--cart, .ec-bottom-nav__item--cart').forEach(el => {
      el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
    });

    /* Close */
    document.querySelector('.ec-cart-drawer__close')?.addEventListener('click', closeDrawer);
    document.querySelector('.ec-cart-overlay')?.addEventListener('click', closeDrawer);

    /* Quick-add from product card */
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('.ec-card__quick-add');
      if (!btn) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'AGREGANDO...';
      await addToCart(variantId);
      btn.textContent = '✓ AGREGADO';
      setTimeout(() => { btn.textContent = 'AGREGAR AL CARRITO'; }, 2000);
      openDrawer();
    });

    /* Initial cart count */
    fetchCart().then(cart => {
      document.querySelectorAll('.ec-header__cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
  });
})();
